import { render, staticRenderFns } from "./GeolocationApiSettings.vue?vue&type=template&id=633097c4&"
import script from "./GeolocationApiSettings.vue?vue&type=script&lang=js&"
export * from "./GeolocationApiSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports